
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ayuda",
      function () {
        return require("private-next-pages/ayuda/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ayuda"])
      });
    }
  